import { Col, Empty, List, Row, Typography } from 'antd';
import React, { useState } from 'react';
import moment from 'moment';

const { Text } = Typography;

function FeedbackDetails({ feedback }) {
  return (
    <div>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col span={8}>Status :</Col>
        <Col span={16}>
          <Text strong>{feedback.isOpen ? 'Open' : 'Close'}</Text>
        </Col>
      </Row>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col span={8}>Title :</Col>
        <Col span={16}>
          <Text strong>{feedback.title}</Text>
        </Col>
      </Row>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col span={8}>Start Date :</Col>
        <Col span={16}>
          <Text strong>{feedback.startDate}</Text>
        </Col>
      </Row>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col span={8}>End Date :</Col>
        <Col span={16}>
          <Text strong>{feedback.endDate}</Text>
        </Col>
      </Row>
      {feedback.questions.length ? (
        <List
          size="large"
          bordered
          dataSource={feedback.questions}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                title={item.question}
                description={`Type: ${
                  item.type
                } | Is Optional: ${item.isOptional.toString()}`}
              />
            </List.Item>
          )}
        />
      ) : (
        <Empty />
      )}
    </div>
  );
}

export default FeedbackDetails;
